import { render, staticRenderFns } from "./address.vue?vue&type=template&id=4d68cd4c&scoped=true&"
import script from "./address.vue?vue&type=script&lang=js&"
export * from "./address.vue?vue&type=script&lang=js&"
import style0 from "./address.vue?vue&type=style&index=0&id=4d68cd4c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d68cd4c",
  null
  
)

export default component.exports